import React from 'react';

import { useAuth } from '~/context/AuthContext';
import { Container } from './styles';

import InputUserInfo from '../InputUserInfo';
import InputUserInfoByDistance from '../InputUserInfoByDistance';

function UserInfo({
  toggleModalOperation,
  setDeliveryTax,
  discount,
  discountObs,
  adminPassword,
  setAdminPassword,
  setHasDeliveryTax,
  hasDeliveryTax,
  session,
}) {
  const { user } = useAuth();

  const userDeliveryByDistance =
    user?.delivery_info?.is_delivery_by_distance ||
    user?.delivery_info?.delimit_by_area;

  return (
    <Container>
      <h4>Informações do cliente</h4>

      {userDeliveryByDistance ? (
        <InputUserInfoByDistance
          toggleModalOperation={toggleModalOperation}
          setDeliveryTax={setDeliveryTax}
          discount={discount}
          discountObs={discountObs}
          adminPassword={adminPassword}
          setAdminPassword={setAdminPassword}
          user={user}
          hasDeliveryTax={hasDeliveryTax}
          setHasDeliveryTax={setHasDeliveryTax}
          session={session}
        />
      ) : (
        <InputUserInfo
          setDeliveryTax={setDeliveryTax}
          toggleModalOperation={toggleModalOperation}
          discount={discount}
          discountObs={discountObs}
          adminPassword={adminPassword}
          setAdminPassword={setAdminPassword}
          user={user}
          hasDeliveryTax={hasDeliveryTax}
          setHasDeliveryTax={setHasDeliveryTax}
        />
      )}
    </Container>
  );
}

export default UserInfo;
